function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FF7000;}\n");
var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M62.1,63.2l-4.2-15.5l-0.2,0.1c-2.8,1.3-5.7,2.8-8.5,4.4H49v30.9h5.5V55.2l4.6,16v0.2h5.3l4.7-16.1v27.9h5.6 V46.9h-8.4L62.1,63.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M91.2,56.9h-1.4c-3.2,0-5.6,0.7-7,2s-2.2,3.6-2.2,6.6v9c0,3,0.8,5.2,2.4,6.6c1.6,1.3,4,2,7.3,2h7.5v-4.9h-8 c-1.2,0-2-0.2-2.6-0.7c-0.5-0.5-0.8-1.1-0.8-2v-3.2h13.2v-7.1c0-2.7-0.7-4.8-2.1-6.2C96,57.7,93.9,56.9,91.2,56.9z M86.4,64.5 c0-0.9,0.2-1.6,0.6-2.1c0.4-0.4,1.2-0.6,2.3-0.6h2c0.8,0,1.4,0.2,1.9,0.7s0.7,1,0.7,1.7v3.2h-7.5V64.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M112.2,50.9h-5.7v6H103v4.9h3.5v14.7c0,1.9,0.5,3.5,1.6,4.7s2.6,1.9,4.6,1.9h5.7v-4.9H114 c-0.7,0-1.2-0.1-1.5-0.3c-0.2-0.2-0.4-0.6-0.4-1.1v-15h6.2v-4.9h-6.2L112.2,50.9L112.2,50.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M141.9,78.2c-0.2-0.1-0.3-0.3-0.3-0.6v-12c0-3-0.8-5.2-2.4-6.5c-1.6-1.4-4-2-7.3-2h-7.3V62h7.8 c1.2,0,2,0.2,2.6,0.7c0.5,0.5,0.8,1.1,0.8,2v1.9h-5c-5.6,0-8.4,2.8-8.4,8.3v1c0,2.6,0.7,4.5,2.1,5.7c1.3,1.1,3.5,1.7,6.3,1.7h3.7 c1.3,0,2.4-0.4,3.3-1.2c0.3,0.3,0.7,0.6,1.1,0.8c0.6,0.3,1.2,0.5,1.8,0.5h3.5v-4.6h-0.6C142.6,78.5,142.1,78.3,141.9,78.2z  M128.2,73.8c0-0.7,0.2-1.3,0.7-1.7c0.5-0.5,1.1-0.7,1.9-0.7h5v4.9c0,0.6-0.1,1.1-0.3,1.5c-0.2,0.3-0.7,0.4-1.5,0.4h-3.7 c-0.8,0-1.3-0.1-1.6-0.4s-0.5-0.8-0.5-1.5L128.2,73.8L128.2,73.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M155.3,78c-0.1-0.1-0.2-0.4-0.2-0.7V46.9h-5.7v30.6c0,1.9,0.5,3.3,1.6,4.2c1,0.9,2.2,1.4,3.6,1.4h3.5v-4.9 h-1.7C155.6,78.2,155.4,78.1,155.3,78z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M173.1,56.9h-1.4c-3.2,0-5.6,0.7-7,2s-2.2,3.6-2.2,6.6v9c0,3,0.8,5.2,2.4,6.6c1.6,1.3,4,2,7.3,2h7.5v-4.9h-8 c-1.2,0-2-0.2-2.6-0.7c-0.5-0.5-0.8-1.1-0.8-2v-3.2h13.2v-7.1c0-2.7-0.7-4.8-2.1-6.2C177.9,57.7,175.8,56.9,173.1,56.9z  M168.3,67.5v-2.9c0-0.9,0.2-1.6,0.6-2.1c0.4-0.4,1.2-0.6,2.3-0.6h2c0.8,0,1.4,0.2,1.9,0.7s0.7,1,0.7,1.7v3.2H168.3z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "208.3,56.9 201,56.9 193.8,64.7 193.8,46.9 188.1,46.9 188.1,83.1 193.8,83.1 193.8,72 194.6,71.2  201.7,83.1 208.4,83.1 198.7,67.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M220.4,50.9h-5.7v6h-3.5v4.9h3.5v14.7c0,1.9,0.5,3.5,1.6,4.7s2.6,1.9,4.6,1.9h5.7v-4.9h-4.4 c-0.7,0-1.2-0.1-1.5-0.3c-0.2-0.2-0.4-0.6-0.4-1.1v-15h6.2v-4.9h-6.2L220.4,50.9L220.4,50.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M236.6,57.8v-0.9h-5.5v26.2h5.7V64.8c0-0.6,0.2-1.2,0.7-1.8s1.2-0.9,2.1-0.9h5V57h-4.5 C238.9,56.9,237.7,57.2,236.6,57.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M265.4,59c-1.6-1.4-4-2-7.3-2h-0.7c-3.2,0-5.7,0.7-7.3,2c-1.6,1.4-2.4,3.6-2.4,6.5v9c0,3,0.8,5.2,2.4,6.5 c1.6,1.4,4,2,7.3,2h0.7c3.2,0,5.7-0.7,7.3-2c1.6-1.4,2.4-3.6,2.4-6.5v-9C267.8,62.6,267,60.4,265.4,59z M253.5,75.5v-11 c0-0.9,0.3-1.5,0.8-2c0.6-0.5,1.4-0.7,2.6-0.7h1.8c1.2,0,2,0.2,2.6,0.7c0.5,0.5,0.8,1.1,0.8,2v11c0,0.9-0.3,1.5-0.8,2 c-0.6,0.5-1.4,0.7-2.6,0.7h-1.8c-1.2,0-2-0.2-2.6-0.7C253.7,77.1,253.5,76.4,253.5,75.5z"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M90.4,6.9c-2.7-1.5-6.2-1.6-9.9-0.4c-4.1,1.4-14.3,6.7-21.5,26c-0.1,0.4-0.1,0.8,0.1,1.2 c0.2,0.4,0.5,0.7,1,0.8c0.8,0.3,1.8-0.2,2.1-0.9C66.7,21.1,74,12,81.6,9.4c2.7-0.9,5.3-0.9,7.1,0.1c7.5,4.1,8,17.2,1.4,35.8 c-0.1,0.4-0.1,0.8,0.1,1.2s0.5,0.7,1,0.8c0.2,0,0.3,0.1,0.5,0.1c0.7,0,1.3-0.4,1.5-1.1C102.9,18.8,95.6,9.8,90.4,6.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M78.8,37.2c-0.5-0.3-12.4-6.6-40.8,10.9C11.4,64.5,6.7,78,6,81.7c-0.6,2.6-0.3,4.8,0.8,6.4 c1.9,2.7,6.6,4.8,13.4,4.8c6.4,0,14.6-1.8,24.2-6.7c0.8-0.4,1.2-1.4,0.7-2.3c-0.4-0.8-1.4-1.2-2.3-0.7c-18.5,9.4-30.8,6.6-33.3,3 c-0.5-0.7-0.6-2.1-0.2-3.7c1.5-7,10.3-18.9,30.5-31.4c26.3-16.2,37.2-11,37.4-10.9c0.8,0.4,1.8,0.2,2.3-0.7 C80,38.7,79.7,37.7,78.8,37.2z"
}));
function SvgLogodark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297.6 99.2",
    style: {
      enableBackground: "new 0 0 297.6 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogodark);
export default __webpack_public_path__ + "static/media/logo.dark.7c7e14a2.svg";
export { ForwardRef as ReactComponent };